import { FormType } from '../../../form-types';
import { AntiNauseaFollowupQuestionFieldAnswers } from './questions';

const antiNauseaFollowup: FormType<AntiNauseaFollowupQuestionFieldAnswers> = {
  name: 'Anti Nausea Follow Up',
  questions: [
    'antiNauseaFollowup_sex',
    {
      key: 'antiNauseaFollowup_healthChanges',
      next: {
        condition: { 'antiNauseaFollowup_healthChanges.yes': true },
        key: 'antiNauseaFollowup_healthChangesDetails',
        els: 'antiNauseaFollowup_medicationDoing'
      }
    },
    'antiNauseaFollowup_healthChangesDetails',
    {
      key: 'antiNauseaFollowup_medicationDoing',
      next: {
        condition: { 'antiNauseaFollowup_medicationDoing.not_well': true },
        key: 'antiNauseaFollowup_medicationExperience',
        els: 'antiNauseaFollowup_sideEffects'
      }
    },
    'antiNauseaFollowup_medicationExperience',
    {
      key: 'antiNauseaFollowup_sideEffects',
      next: {
        condition: { 'antiNauseaFollowup_sideEffects.yes': true },
        key: 'antiNauseaFollowup_sideEffectsDetails',
        els: 'antiNauseaFollowup_treatmentPreference'
      }
    },
    'antiNauseaFollowup_sideEffectsDetails',
    'antiNauseaFollowup_treatmentPreference',
    'antiNauseaFollowup_additionalQuestions',
    {
      key: 'antiNauseaFollowup_truthfulnessConsent',
      next: {
        condition: {
          'antiNauseaFollowup_truthfulnessConsent.non_consent': true
        },
        key: 'antiNauseaFollowup_ineligible',
        els: 'antiNauseaFollowup_treatmentConsent'
      }
    },
    {
      key: 'antiNauseaFollowup_treatmentConsent',
      next: {
        condition: {
          'antiNauseaFollowup_treatmentConsent.do_not_proceed': true
        },
        key: 'antiNauseaFollowup_ineligible',
        els: 'antiNauseaFollowup_complete'
      }
    },
    'antiNauseaFollowup_complete',
    'antiNauseaFollowup_ineligible'
  ]
};

export default antiNauseaFollowup;
